import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import Home from '../views/Home.vue'
import About from '../views/About.vue'
import Login from '../views/Login.vue'
import Admin_Index from '../views/admin/index.vue'

import auth from '../middleware/auth';
import hasAuth from '../middleware/event';
import preview from '../middleware/preview';
import sendToken from '../middleware/redirect';

Vue.use(VueRouter)

  const routes = [
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      layout: "none"
    }
  },
  {
    path: '/',
    name: 'Landing',
    component: () => import('../views/Landing.vue'),
    meta: {
      layout: "event"
    }
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: "/admin",
    name: "admin",
    component: Admin_Index,
    meta: {
      middleware: auth,
      layout: "admin"
    }
  },
  {
    path: "/admin/:id",
    name: "event-dashboard",
    component: () => import('../views/admin/dash.vue'),
    meta: {
      layout: "admin"
    }
  },
  {
    path: "/admin/:id/preview",
    name: "event-preview",
    component: () => import('../views/watch-page/index.vue'),
    meta: {
      layout: "event",
      middleware: preview
    }
  },
  {
    path: "/present/:id",
    name: "event-present",
    component: () => import('../views/admin/present.vue'),
    meta: {
      layout: "event",
      middleware: [auth, preview]
    }
  },
  {
    path: "/callback",
    name: "AuthRedirect",
    component: () => import('../views/redirect.vue'),
    meta: {
      middleware: sendToken
    }
  },
  {
    path: "/:eventUrl/authenticate",
    name: "Authenticate",
    component: () => import('../views/EventAuth.vue'),
    meta: {
      middleware: (context:any) => {
        store.dispatch("API_CALL", { method: "get", url: "/events/url/" + context.to.params.eventUrl + "?public=true"}).then((res) => {
          store.commit("setEvent", res.data);
          context.next();
        })
      },
      layout: "none"
    }
},
  {
    path: "/:eventUrl",
    name: "WatchPage",
    component: () => import('../views/watch-page/index.vue'),
    meta: {
      middleware: hasAuth,
      layout: "event"
    }
  },
]

const router = new VueRouter({
  mode: "history",
  routes
})

router.beforeEach((to: any, from, next) => {
  if(!to.meta.middleware) return next()
  const context = { to, from, next, router }

  if(typeof to.meta.middleware !== 'object') {
    return to.meta.middleware({ ...context });
  } else {
    to.meta.middleware.forEach((mid:any) => {
      return mid({ ...context });
    })
  }
})

export default router
